import { Close, History } from "@mui/icons-material";
import {
  Box,
  Drawer,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import useRecordHistoryEvent from "hooks/useRecordHistoryEvent";
import { Dispatch, SetStateAction } from "react";
import { Waypoint } from "react-waypoint";
import { RecordHistoryEvent } from "types/recordHistoryEvent";

export interface InventoryPartEventsDrawerProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  inventoryPartId: number | undefined;
}

export default function InventoryPartEventsDrawer({ open, setOpen, inventoryPartId }: InventoryPartEventsDrawerProps) {
  const { events, fetchMoreEvents, hasMoreEvents, isLoading } = useRecordHistoryEvent({
    entityId: inventoryPartId,
    eventType: "inventory_part_events",
  });

  return (
    <Drawer open={open} onClose={() => setOpen(false)} anchor="right">
      <Box p={2} width={400}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" alignItems="center" gap={1}>
            <History color="primary" fontSize="large" />
            <Typography variant="h6">Event History</Typography>
          </Stack>
          <IconButton onClick={() => setOpen(false)}>
            <Close />
          </IconButton>
        </Stack>
        <List>
          {events &&
            events.map(({ id, description }: RecordHistoryEvent) => (
              <ListItem divider key={id}>
                <ListItemText primary={description} />
              </ListItem>
            ))}
          {!isLoading || !hasMoreEvents ? (
            <Waypoint onEnter={fetchMoreEvents} />
          ) : (
            <ListItem>
              <ListItemText primary="Fetching events..." secondary={<LinearProgress />} />
            </ListItem>
          )}
        </List>
      </Box>
    </Drawer>
  );
}
